import { useEffect, useState } from 'react'

import { Outlet, useLocation } from 'react-router-dom'

import { LoginForm } from 'pages/auth/view/LoginForm'
import { RecoverAccount } from 'pages/auth/view/RecoverAccount/RecoverAccount'
import { ResetPassword } from 'pages/auth/view/RecoverAccount/ResetPassword'
import { Register } from 'pages/auth/view/Register/Register'

import {
    AuthModalProvider,
    useAuthModalContext
} from './components/AuthmodalContext'
import Footer from './components/footer'
import MobileView from './components/mobileView'
import Navbar from './components/navbar'
import AgeVerificationModal from './modals/AgeVerificationModal'

export type AuthPanel =
    | 'default'
    | 'login'
    | 'signup'
    | 'forgetPassword'
    | 'resetPassword'

function LandingPageInner() {
    const [isMobileView, setIsMobileView] = useState<boolean | null>(null)
    const [showAgeVerification, setShowAgeVerification] = useState(false)
    const [activePanel, setActivePanel] = useState<AuthPanel>(() =>
        sessionStorage.getItem('pending_social_2fa')
            ? 'login'
            : 'default'
    )

    const location = useLocation()
    const modalData = useAuthModalContext()
useEffect(() => {
    requestAnimationFrame(() => {
        window.scrollTo(0, 0)
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
    })
}, [location.pathname])
    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobileView(window.innerWidth <= 768)
        }

        checkIsMobile()

        window.addEventListener('resize', checkIsMobile)

        return () => {
            window.removeEventListener('resize', checkIsMobile)
        }
    }, [])

    useEffect(() => {
        const alreadyVerified =
            localStorage.getItem('age_verified') === 'true'

        if (!alreadyVerified) {
            setShowAgeVerification(true)
        }
    }, [])

    useEffect(() => {
        const params = new URLSearchParams(location.search)

        if (
            location.pathname === '/reset-password' &&
            params.get('token') &&
            params.get('email')
        ) {
            setActivePanel('resetPassword')
        }
    }, [location.pathname, location.search])

    useEffect(() => {
        if (isMobileView !== false) {
            return
        }

        if (activePanel === 'default') {
            modalData.clearModal()
            return
        }

        if (activePanel === 'login') {
            modalData.addModal(
                'login',
                <LoginForm setActivePanel={setActivePanel} />,
                true,
                false
            )
            return
        }

        if (activePanel === 'signup') {
            modalData.addModal(
                'signup',
                <Register />,
                true,
                false,
                true
            )
            return
        }

        if (activePanel === 'forgetPassword') {
            modalData.addModal(
                'forgetPassword',
                <RecoverAccount
                    setActivePanel={setActivePanel}
                />,
                true,
                false
            )
            return
        }

        if (activePanel === 'resetPassword') {
            modalData.addModal(
                'resetPassword',
                <ResetPassword
                    setActivePanel={setActivePanel as any}
                />,
                true,
                false
            )
        }
    }, [activePanel, isMobileView])

    if (isMobileView === null) {
        return null
    }

return (
    <div className="landing-page">
        {isMobileView ? (
            <MobileView />
        ) : (
            <div
                style={{
                    width: '100%',
                    background: '#fff'
                }}
            >
                <Navbar setActivePanel={setActivePanel} />

                <Outlet context={{ setActivePanel }} />

                <Footer />
            </div>
        )}

        {showAgeVerification && (
            <AgeVerificationModal
                onClose={() => {
                    setShowAgeVerification(false)
                }}
                onConfirm={() => {
                    localStorage.setItem(
                        'age_verified',
                        'true'
                    )

                    setShowAgeVerification(false)
                }}
            />
        )}
    </div>
)
}

function LandingPage() {
    return (
        <AuthModalProvider>
            <LandingPageInner />
        </AuthModalProvider>
    )
}

export default LandingPage